import services from '../../services'
import Cookies from 'js-cookie'
import { formatDate, __handleDate } from '@/utils/date.js'

// 是否为生产环境
const isProduction = process.env.VUE_APP_BUILD_ENV === 'prod'

const state = {
    lang: 'zh_CN',
    currencySymbol: '￥',
    env: {},
    user: {},
    header: {},
    sso: {},
    isCustManage: false,
    messageShow: false, // 用于切换公共top组件是否弹出提示标识
    ssoDailog: null,
    exhiId: null, // 展会id
    exhiFromId: '',
    exhiType: '', // 展会类型 manualExhi = 手工创建; CIMSExhi = CIMS展会; MRSSingleExhi = MRS单团祖; MRSMultipleExhi = MRS多团组
    topMenuActiveIndex: '',
    activeIndex: null,
    isShowBreadcrumb: false,
    BreadcrumbData: [],
    breadcrumbForConfig: {}, // 资源配置面包屑
    orderConfig: [{ value: '酒店订单', key: 'hotelOrder' }],
    defaultCurrencyList: [],
    countryList: [],
    timeZoneList: [],
    exhiConfig: null,
    imgurl: '',
    showNoPermission: false,
    startDate: '',
    endDate: '',
    itravelPath: isProduction ? 'https://itravel.huawei.com/home/index?tab=train&service=&tripType=' : 'http://itravel-uat.huawei.com/home/index?tab=train&service=&tripType=', // 差旅系统地址火车票
    itravelTicker: isProduction ? 'http://itravel.huawei.com/home/index?tab=flight&service=flight&tripType=1' : 'http://itravel-uat.huawei.com/home/index?tab=flight&service=flight&tripType=1', // 差旅系统地址机票
    tripPath: isProduction ? 'https://www.hwtrip.com/' : 'http://10.162.24.231/', // 爱旅系统地址
    mrsPath: isProduction ? 'http://w3.huawei.com/mrs/' : 'http://kweuat.huawei.com/mrs/', // MRS系统地址
    payPath: isProduction ? 'https://pay.hwht.com/gateway.do' : 'https://pay-uat.hwht.com/gateway.do', // 支付地址
    icimsPath: process.env.VUE_APP_BUILD_ENV === 'prod' ? 'http://w3.huawei.com/icims' : 'http://kweuat.huawei.com/icims',
    // 防止多次请求校验公司预定、用车方案 其他需要用到校验判断的去store的值
    isReqCompany: false, // 判断判断公司预定权限是否有请求过
    isReqVehicle: false, // 判断用车预定权限是否有请求校验过
    isCompanyPer: false, // 是否拥有公司酒店预定权限
    isVehiclePre: false, // 是否拥有用车的预定权限
    isShowRegistAndSchedule: false, // 是否展示报名注册、议程管理菜单,
    isRegistManage: false, // 展会或报名资源管理员
    isFirstInterface: false, // 一线接口人
    onlyFirstInterface: false, // 仅一线接口人
    seatApprovers: [], // 报名注册管理员
    phoneAreaCodes: [], // lookup区号
    approveStatusLookup: [], // lookup审批状态
    empAttendStatusLookup: [], // 员工参会状态 000-取消，200-待接口人审批，800-参会，070-驳回
    guestAttendStatusLookup: [], // 嘉宾参会状态 已参会'1'，取消参会'0'
    seatStatusLookup: [], // 座位号状态 0未注册 1已注册 2已作废
    interfaceDeadHour: 0,
    currentFlag: 0, // 标记current请求 0 1 切换
    isBlacklistManage: false, // 黑名单管理
    onlyCheckInStaff: false, // 签到工作人员
    isReviewApprover: false, // 权限复核人
    onlyReviewApprover: false, // 权限复核人
    defaultRoles: ['Tourists0', 'Casual', 'Guest'] // 默认角色

}

const lookupStore = {
    INTERNATIONAL_AREA_CODE: { // 区号
        list: 'phoneAreaCodes',
        appName: 'eventsgocommon'
    },
    APPROVE_STATUS: { // 审批状态
        list: 'approveStatusLookup'
    },
    GUEST_ATTEND_STATUS: {
        list: 'guestAttendStatusLookup'
    },
    EMP_MEETING_STATUS: {
        list: 'empAttendStatusLookup',
        appName: 'eventsgocommon'
    },
    SEAT_STATUS: {
        list: 'seatStatusLookup'
    }
}

const getters = {

    /** 展会已结束 */
    exhiIsEnd({ exhiConfig }) {
        if (exhiConfig && exhiConfig.endDate) {
            let today = __handleDate(formatDate(new Date(), 'YY-MM-DD'))
            let exhiEnd = __handleDate(exhiConfig.endDate)
            return today > exhiEnd
        }
        return false
    }
}
const mutations = {

    /**
     * 设置外部系统地址
     */
    setOutsideUrlMut(state, payload) {
        state[payload.itemCode] = payload.itemName
    },

    /**
     * 设置公司预定权限已经请求过了，并设置是否有公司预定的权限
     */
    setCompanyPer(state, payload) {
        state.isReqCompany = payload.isLoaded
        state.isCompanyPer = payload.isOwn
    },

    /**
     * 设置公司订车权限已经请求过了，并设置是否有公司订车的权限
     */
    setVehiclePer(state, payload) {
        state.isReqVehicle = payload.isLoaded
        state.isVehiclePre = payload.isOwn
    },

    /**
     * 设置面包屑显示的值
     */
    setBreadcrumbData(state, payload) {
        state.BreadcrumbData = payload.data
        // 主动控制面包屑隐藏
        if (payload.isHide) {
            state.isShowBreadcrumb = !payload.isHide
        } else {
            state.isShowBreadcrumb = true
        }
    },

    /**
     * 设置面包屑显示的值
     */
    setBreadcrumbForConfig(state, payload) {
        state.isShowBreadcrumb = false
        // 默认为true
        if (payload.isShow === undefined) {
            payload.isShow = true
        }
        state.breadcrumbForConfig = payload
    },
    setEnvironment(state, { data, headers }) {
        state.env = data
        state.user = data.user
        state.header = headers
        let roleList = data.user && data.user.validRoles || []
        const validRoles = roleList.filter(el => !state.defaultRoles.includes(el.roleName))
        // 展会管理员、系统管理员、配置管理员、报名资源管理员
        state.isShowRegistAndSchedule = validRoles.some(item => [
            '展会管理员(Events Admin)',
            '系统管理员(System Admin-ATE)', '系统管理员(System Admin-BTE)', 'System Admin',
            '配置管理员(Configure Admin-ATE)', '配置管理员(Configure Admin-BTE)',
            '报名资源管理员'
        ].indexOf(item.roleName) > -1)
        // 展会管理员、报名资源管理员、一线接口人
        state.isRegistManage = validRoles.some(item => [
            '展会管理员(Events Admin)',
            '系统管理员(System Admin-ATE)', '系统管理员(System Admin-BTE)', 'System Admin',
            '报名资源管理员'
        ].indexOf(item.roleName) > -1)
        // 一线接口人
        state.isFirstInterface = validRoles.some(item => item.roleName === '一线接口人')
        // 仅一线接口人(不包含管理员)
        state.onlyFirstInterface = state.isFirstInterface && !state.isRegistManage
        state.isReviewApprover = validRoles.some(item => item.roleName === '权限复核人')
        state.currentFlag = state.currentFlag === 0 ? 1 : 0
        // 展会管理员、系统管理员、报名资源管理
        state.isBlacklistManage = validRoles.some(item => [
            '展会管理员(Events Admin)',
            '系统管理员(System Admin-ATE)', '系统管理员(System Admin-BTE)', 'System Admin',
            '报名资源管理员'
        ].indexOf(item.roleName) > -1)
        state.onlyCheckInStaff = false
        if (validRoles.length > 0) {
            state.onlyCheckInStaff = validRoles.every(item => item.roleName === '签到工作人员')
        }
        state.onlyReviewApprover = false
        if (validRoles.length > 0) {
            state.onlyReviewApprover = validRoles.every(item => item.roleName === '权限复核人')
        }
    },
    setExhiConfigInfo(state, data) {
        state.exhiConfig = data || {}
        state.exhiFromId = data.exhiFromId || ''
        state.exhiId = data.exhiId ? String(data.exhiId) : ''
        state.currencySymbol = data.currencySymbol
        state.startDate = data.startDate
        state.endDate = data.endDate
        // 临时处理方案
        state.isCustManage = state.user.userType !== 'E_PT' && data.exhiFromId
    },
    // 座位审批人
    setSeatApprovers(state, payload) {
        state.seatApprovers = payload
    },
    doLogout(state) {
        Cookies.remove('hwsso_login', { path: '/', domain: '.huawei.com' })
        Cookies.remove('login_uid', { path: '/', domain: '.huawei.com' })
        Cookies.set('login_logFlag', 'out', { path: '/', domain: '.huawei.com' })

        state.env = {}
        state.user = {}
    },
    rebuildSession(state, data) {
        state.sso = data
    },
    setSsoDailog(state, vm) {
        state.ssoDailog = vm
    },
    // 设置顶导航点亮的tab
    setTopMenuActiveIndex(state, data) {
        state.topMenuActiveIndex = data
    },
    // 设置顶导航下拉菜单配置列表
    setTopMenuConfig(state, data) {
        state.menuConfig = data
    },
    // 设置记录是否展示提示
    setMessageShow(state, data) {
        state.messageShow = data
    },
    // 设置语言
    setLang(state, data) {
        localStorage.setItem('language', data)
        state.lang = data === 'zh_CN' ? 'zh_CN' : 'en_US'
    },
    // 币种
    setDefaultCurrencyList(state, data) {
        state.defaultCurrencyList = data
    },
    // 国家
    setCountryList(state, data) {
        if (data) {
            data.forEach(el => {
                el.countryName = state.lang === 'zh_CN' ? el.country_alias_short_name_cn : el.country_alias_short_name_en
            })
        }
        state.countryList = data
    },
    // 时区
    setTimeZoneList(state, data) {
        state.timeZoneList = data
    },

    /**
     * 设置展会资源首页图片
    */
    setImgurl(state, data) {
        state.imgurl = data
    },

    /**
     * 显示隐藏无权限提示页面
     */
    setShowNoPremission(state, payload) {
        state.showNoPermission = payload
    },

    /**
     * 电话区号
     */
    setAreaCode(state, payload) {
        state.phoneAreaCodes = payload
    },

    /**
     * 展会类型
     */
    setExhiType(state, payload) {
        state.exhiType = payload
    },
    setLookup(state, payload) {
        state[payload.key] = payload.data
    },
    setInterfaceDeadlineAfterHour(state, payload) {
        state.interfaceDeadHour = payload
    }
}

const actions = {

    /** 第三方登录获取跳转机票火车票的地址 */
    getTravelLoginurlAct(context, param) {
        return new Promise((resolve, reject) => {
            services.commonSer.getTravelLoginurlSer(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /** 是否为关联ICIMS的展会 */
    isIcimsExhiAct(context, param) {
        return new Promise((resolve, reject) => {
            services.commonSer.getIsIcimsExhiSer(param).then((res) => {
                resolve(res && res.data || {})
            }).catch(err => { reject(err) })
        })
    },

    /**
     * 国家/省会/城市
     */
    getCountryList(context, param) {
        return new Promise((resolve, reject) => {
            if (param.param.level === 'country' && context.state.countryList.length) {
                resolve(context.state.countryList)
            } else {
                services.commonSer.getCountryList(param).then((res) => {
                    const arr = res && res.data && res.data.data || []
                    // 把中国排第一
                    if (param.param.level === 'country') {
                        arr.sort(el => el.country_alpha_2_code === 'CN' ? -1 : 1)
                        context.commit('setCountryList', arr)
                    }
                    resolve(arr)
                }).catch(error => {
                    reject(error)
                })
            }
        })
    },

    /**
     * 省/州
     */
    getProvinceList(context, param) {
        return services.commonSer.getCountryList(param)
    },

    /**
     * 城市
     */
    getCityList(context, param) {
        return services.commonSer.getCountryList(param)
    },

    /**
     * 通过城市反查国家省份信息
     */
    getCountryProvinceInfo(context, param) {
        return new Promise((resolve, reject) => {
            services.commonSer.getCountryList(param).then((res) => {
                resolve(res && res.data && res.data.data || [])
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 行政区
     */
    getDistrictCodeList(context, param) {
        return services.commonSer.getCountryList(param)
    },

    /**
     * 展会默认币种名称
     */
    getDefaultCurrency(context, param) {
        return new Promise((resolve, reject) => {
            services.commonSer.getDefaultCurrency(param).then((res) => {
                context.commit('setDefaultCurrencyList', res && res.data && res.data.data || [])
                resolve(res)
            })
        })
    },

    /**
     * 登陆后获取环境信息
     */
    getEnvInfo(context, params) {
        return new Promise((resolve, reject) => {
            services.commonSer.fechEnv(params).then(data => {
                context.commit('setEnvironment', data)
                resolve(data)
            })
        })
    },

    /**
     * 时区
     */
    getTimeZone(context, param) {
        return services.commonSer.getTimeZone(param)
    },
    getExhiConfig(context, param) {
        return new Promise((resolve, reject) => {
            services.homeSer.getResExhiConfig(param).then(({ data }) => {
                const cfg = data.data || { exhiId: param.exhiId }
                console.log(cfg, '-----cfg')
                context.commit('setExhiConfigInfo', cfg)
                // 转审审批人
                context.commit('setSeatApprovers', cfg.userList || [])
                resolve(data.data)
            })
        });
    },
    // lookup查询 req表示重新请求
    getLookUpData(context, param) {
        return new Promise((resolve, reject) => {
            const store = lookupStore[param.classifyCode]
            const key = store ? store.list : ''
            if (context.state[key] && context.state[key].length && !param.req) {
                resolve(context.state[key])
            } else {
                if (store) { // 增加参数
                  param.appName = store.appName || ''
                }
                services.commonSer.getLookUpData(param).then((res) => {
                    const data = res.data.data || []
                    if (key) {
                        context.commit('setLookup', { key, data })
                    }
                    resolve(data)
                })
            }
        });
    },
    // 一线接口人在报名截止n小时后禁止操作
    getInterfaceDeadAfterHour(context, param) {
        return new Promise((resolve, reject) => {
            if (context.state.interfaceDeadHour) {
                resolve(context.state.interfaceDeadHour)
            } else {
                services.commonSer.getLookUpData({ classifyCode: 'Interface_Deadline_After_Hour' }).then(({ data }) => {
                    const list = data.data || []
                    const hour = list[0] ? Number(list[0].itemName) : 0
                    context.commit('setInterfaceDeadlineAfterHour', hour)
                    resolve(hour)
                })
            }
        });
    },

    /** 上传附件 */
    uploadAttachmentAct(context, param) {
        return services.commonSer.uploadAttachmentSer(param)
    },
    // 切换语言
    switchLanguageAct(context, param) {
        return services.commonSer.switchLanguageSer(param)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
